import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import '@expo/match-media';
import { useMediaQuery } from "react-responsive";
import SelectionScreen from './SelectionScreen'
import Navigator from '../navigation'
import * as Linking from 'expo-linking';

const MobWeb = () => {

    const isTabletOrMobileDevice = useMediaQuery({    
        maxDeviceWidth: 1224,
        // alternatively...
        query: "(max-device-width: 1224px)"  
      });

      if (isTabletOrMobileDevice) {
        return (
          <View style={{justifyContent: 'center', alignItems: 'center', flex: 1}} >
            <View style={{flexDirection: 'row', marginVertical: 20}}>
             <Text style={{fontSize: 25, color: '#2fd756', fontWeight: '500', fontFamily: 'rubikRegular'}}>Czyste</Text>
              <Text style={{fontSize: 25, color: '#000000', fontWeight: '500', fontFamily: 'rubikRegular'}}>Miasto. </Text>
           </View>
        <Text>Witaj użytkowniku mobilny 👋</Text>
        <Text style={{textAlign: 'center'}}>Aby skorzystać z naszej platformy na urządzeniu mobilnym pobierz naszą aplikację klikając poniżej</Text>
          <Text onPress={() => {    Linking.openURL('https://drive.google.com/file/d/1V5ovcAp_Oqb73S0wW1SqyCffi6VTKKiQ/view');
}} style={{fontSize: 20, color: '#2fd756', fontWeight: '500', fontFamily: 'rubikRegular'}} >Pobierz</Text>
        </View>
        )
      }
      return (<Navigator />)

}

export default MobWeb;